import { ITypedReduxAction } from '../../types/redux/actionType';
import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ELkTypeActionTypes {
  SetLkType = 'lkType/set',
}

export type TSetLkType = ITypedReduxAction<ELkTypeActionTypes.SetLkType, ELkType | null>;

export const setLkType: (lkType: ELkType | null) => TSetLkType = actionGenerator<
  ELkTypeActionTypes.SetLkType,
  ELkType | null
>(ELkTypeActionTypes.SetLkType);
